import { Fragment, useState } from 'react';
import { GoChevronDown, GoChevronUp } from 'react-icons/go';

import styles from './DescriptionsCollapse.module.less';

const DescriptionsCollapse = props => {
    const {
        rows,
        collapsedRowCount = 3,
        isCollapsed: isCollapsedProp = true
    } = props;
    const [isCollapsed, setIsCollapsed] = useState(isCollapsedProp);

    //if we have fewer rows than the collapsedRowCount, don't show buttons
    const canCollapse = rows.length > collapsedRowCount;
    //potential props: maxTextLength
    const rowItems = rows.map((row, index) => {
        if (!row) return;
        const [name, value] = row;
        let styleName = 'label';
        if (isCollapsed && index >= collapsedRowCount) {
            styleName = 'label-hidden';
        }
        return (
            <Fragment key={name}>
                <div
                    className={styles[styleName]}
                    style={{ color: 'var(--gray300)' }}
                >
                    {name}
                </div>
                <div className={styles[styleName]}>{value}</div>
            </Fragment>
        );
    });

    return (
        <div className={styles['container']}>
            {rowItems}
            {canCollapse && isCollapsed && (
                <button
                    className={styles['collapse-button']}
                    onClick={() => {
                        setIsCollapsed(false);
                    }}
                >
                    Show details{' '}
                    <GoChevronDown size={14} title="Down Chevron" />
                </button>
            )}
            {canCollapse && !isCollapsed && (
                <button
                    className={styles['collapse-button']}
                    onClick={() => {
                        setIsCollapsed(true);
                    }}
                >
                    Hide Details <GoChevronUp size={14} title="Up Chevron" />
                </button>
            )}
        </div>
    );
};

export default DescriptionsCollapse;
